import React from "react";
import AppHeader from "../../../layout/AppHeader";

const SessionLoading: React.FC = () => {
  return (
    <div className="flex flex-col h-[100dvh] w-full bg-[#FFF8F0] overflow-hidden">
      <AppHeader />
      <div className="flex-1 flex items-center justify-center">
        Loading Session...
      </div>
    </div>
  );
};

export default SessionLoading;
